// images
import medeeImg1 from "../images/blog/1/big.png";
import medeeImg2 from "../images/blog/1/small.png";
import medee2Img1 from "../images/blog/2/big.png";
import medee2Img2 from "../images/blog/2/small.png";
import medee2Img3 from "../images/blog/2/third.png";
import medee3Img1 from "../images/blog/3/big.png";
import medee3Img2 from "../images/blog/3/small.png";
import medee3Img3 from "../images/blog/3/third.png";
import medee4Img1 from "../images/blog/4/big.png";
import medee4Img2 from "../images/blog/4/small.png";
import medee4Img3 from "../images/blog/4/third.png";
import medee5Img1 from "../images/blog/5/big.png";
import medee5Img2 from "../images/blog/5/small.png";
import medee5Img3 from "../images/blog/5/third.png";
import medee6Img1 from "../images/blog/6/big.png";
import medee6Img2 from "../images/blog/6/small.png";
import medee7Img1 from "../images/blog/7/big.jpg";
import medee7Img2 from "../images/blog/7/small.png";
import medee7Img3 from "../images/blog/7/third.png";

import author1 from "../images/users/user1.jpg";

const medeenuud = [
  {
    id: "1",
    thumb: "Анхааруулга",
    title: "Хуурамч мессежээс болгоомжлогтун",
    slug: "khan-bank-message",
    slugmn: "хаан-банк-мессеж",
    create_at: "2025.08.06",
    screens: medeeImg1,
    screens2: medeeImg2,
    description:
      "Банкны нэрийг ашиглан иргэд рүү дараах хуурамч мессежийг илгээж, залилан хийхийг оролдож байгаа тул та бүхэн сэрэмжтэй байна уу.",
    category: "Анхааруулга",
    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
  {
    id: "2",
    thumb: "Мэдээлэл",
    title: "Хаан банк IBAN хялбар боллоо",
    slug: "iban",
    slugmn: "IBAN",
    create_at: "2025.08.17",
    screens: medee2Img1,
    screens2: medee2Img2,
    screen3: medee2Img3,
    description:
      "ХААН Банкны данс хоорондын гүйлгээг 2025 оны 8-р сарын 4-ний өдрөөс эхлэн 20 оронтой IBAN дансны дугаараар хийх зохицуулалт хэрэгжиж эхэлсэн. Үүнтэй холбогдуулан гүйлгээ хийх үед хүлээн авагчийн дансны дугаараар IBAN дугаарыг автоматаар олох “IBAN лавлах” цэсийг Khan Bank аппликэйшнд шинээр нэвтрүүлээд байна.",
    description2:
      "Одоо та Khan Bank аппликэйшнээр данс хооронд болон бусад банк руу гүйлгээ хийхдээ 20 оронтой IBAN дансны дугаарыг заавал асуух шаардлагагүй. Товчхондоо бол “Гүйлгээ” цэс дэх гүйлгээний төрлөө сонгоод “IBAN лавлах” товчийг дарж, хүлээн авагчийн дансны дугаарыг оруулахад тухайн харилцагчийн IBAN дугаар гарч ирнэ. Дараа нь “IBAN хуулах” товчийг дарснаар уг дугаар гүйлгээний талбарт автоматаар байрших бөгөөд баталгаажуулснаар гүйлгээ амжилттай хийгдэнэ.",
    category: "Мэдээлэл",

    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
  {
    id: "3",
    thumb: "Анхааруулга",
    title: "Их хэмжээний хур тунадас орно",
    slug: "boroo",
    slugmn: "хур-тунадас",
    create_at: "2025.08.20",
    screens: medee3Img1,
    screens2: medee3Img2,
    screen3: medee3Img3,
    description:
      "ЦУОШГ: Улаанбаатар хотод бороо өнөөдөр /2025.08.20/ өдөр 05:00 цагаас эхлэн бороо орж 07:00 цагийн байдлаар 1.5~3мм хур тунадас ороод байна. Бороо өдөртөө үргэлжлэн орохыг анхааруулж байна. ",
    description2:
      "ЦУОШГ: ⚠️20-нд Улаанбаатар, Төв, Сэлэнгэ, Орхон, Дархан-Уул аймгийн нутаг, Дундговийн баруун болон хойд хэсгээр, ⚠️20-21-нд шилжих шөнө Төв аймаг болон Дундговийн нутгийн зүүн хэсэг, Говьсүмбэр аймгийн нутаг, Хэнтийн баруун болон хойд хэсэг, Дорнодын хойд хэсгээр , ⚠️21-нд  Дорнодын хойд хэсгээр ахиухан хэмжээний усархаг бороо орно‼️Нөөлөг салхи, аянга, цахилгаан, мөндөр, үер усны аюулаас сэрэмжтэй байхыг анхааруулж байна‼️",
    category: "Анхааруулга",
    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
  {
    id: "4",
    thumb: "Анхааруулга",
    title: "Нарны соронзон шуурганы нөлөөгөөр цаг агаар хүйтэрнэ",
    slug: "soronzon-shuurga",
    slugmn: "соронзон шуурга",
    create_at: "2025.09.02",
    screens: medee4Img1,
    screens2: medee4Img2,
    screen3: medee4Img3,
    description:
      "Наран дээр мягмар гаригт хүчтэй тэсрэлт болж, соронзон шуурга дэгдэнэ хэмээн Одон орон, нарны идэвхижлийн судалгаа хийдэг хүрээлэнгийн судлаачид анхааруулжээ. Энэхүү соронзон шуурга дэлхийг чиглэн ирж энэ сарын 4-6-ны өдрүүдэд Төв Ази, ОХУ, Монгол орны нутгаар нарны соронзон орны идэвхижил өндөр түвшинд хүрэх аж.",
    description2:
      "Үүний улмаас пүрэв гаригт болон пүрэвээс баасан гаригт шилжих шөнө Хөвсгөл, Завхан, Архангай, Булган, Сэлэнгийн ихэнх сумдын нутаг, Төв, Өвөрхангай, Дундговь, Өмнөговийн зарим сумдын нутгаар хур тунадас, Хөвсгөл, Завхан, Архангайн уулсаар, мөн Хэнтийн нуурууны орчмоор нойтон цас орж шөнөдөө эрс хүйтэрнэ. Иймээс эдгээр өдрүүдэд эрүүл мэнддээ онцгой анхаарал хандуулах, тээвэрчид, жолооч нар хөдөө орон нутгийн замд анхаарал болгоомжтой зорчоорой хэмээн тэрбээр анхааруулжээ. ",
    category: "Анхааруулга",
    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
  {
    id: "5",
    thumb: "Мэдээлэл",
    title:
      "2025 оны 11-р сарын 18-наас 11-р сарын 22-нийг хүртэлх цаг агаарын төлөв",
    slug: "tsag-agaar-18-22",
    slugmn: "цаг агаарын төлөв",
    create_at: "2025.11.17",
    screens: medee5Img1,
    screens2: medee5Img2,
    screens3: medee5Img3,
    description:
      "11/19-нд Хэнтийн уулархаг нутгаар ялимгүй цас орно. Бусад хугацаанд цас орохгүй. Салхи 19-нд тал, хээрийн нутгаар секундэд 12-14 метр хүрч ширүүснэ. 18-наас ихэнх нутгаар өдөртөө хүйтний эрч суларч, Дархадын хотгор, Завхан, Заг-Байдраг голын эх, Идэр, Тэс голыг хөндийгөөр шөнөдөө -29…-34 градус, өдөртөө -12…-17 градус",
    description2:
      "Алтай, Хангай, Хөвсгөл, Хэнтийн уулархаг нутаг, Хараа, Ерөө, Туул, Тэрэлж, Хэрлэн голын хөндийгөөр шөнөдөө -21…-26 градус, өдөртөө -7…-12 градус, говийн бүс нутгийн өмнөд хэсгээр шөнөдөө -9…-14 градус, өдөртөө +2…-3 градус, бусад нутгаар шөнөдөө -14…-19 градус, өдөртөө -3…-8 градус хүйтэн байна. Эх сурвалж:  Цаг уур, орчны шинжилгээний газар",
    category: "Мэдээлэл",
    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
  {
    id: "6",
    thumb: "Мэдээлэл",
    title: "ТОМУУ, ТОМУУ ТӨСТ ӨВЧНИЙ НӨХЦӨЛ БАЙДЛЫН МЭДЭЭ",
    slug: "tomuu-tomuu-tost",
    slugmn: "Томуу нөхцөл байдал",
    create_at: "2025.12.03",
    screens: medee6Img1,
    screens2: medee6Img2,
    description:
      "2025 оны 12 дугаар сарын 01-ний өдрийн байдлаар, Улсын хэмжээнд эмнэлэгт 3,401 хүүхэд хэвтэн эмчлүүлж байгаагаас 89.2% (3,035) нь амьсгалын замын цочмог хүнд халдварын шалтгаантай байгаа ба өмнөх өдрөөс 38.1% (n=2,197)-иар нэмэгдсэн байна. Амьсгалын замын цочмог хүнд халдварын шалтгаант жирэмсэн эмэгтэй 72 байна.",
    description2:
      "Хүүхдийн яаралтай тусламжийн тасгаар 3,238 хүүхэд үзүүлснээс томуу, томуу төст өвчний шалтгаантай нь 77.3% (2,502) -ийг эзэлж байна. Өмнөх өдрөөс 37.9% (n=1,814)-иар нэмэгджээ. Улсын хэмжээнд 2,518 ор дэлгэх төлөвлөлт гаргасан. Үүнээс нийслэлд 2,135 орны зохицуулалт хийн дэлгэн ажиллуулж байна. Эх сурвалж: Эрүүл Мэндийн Яам",
    category: "Мэдээлэл",
    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
  {
    id: "7",
    thumb: "Мэдээлэл",
    title: "Төрийн дууллын өдөр",
    slug: "turiinduulal",
    slugmn: "Төрийн дууллын өдөр",
    create_at: "2026.10.20",
    screens: medee7Img1,
    screens2: medee7Img2,
    screen3: medee7Img3,
    description:
      "'Төрийн дууллын өдөр'-ийг тохиолдуулан Монгол Улсын 21 аймаг, нийслэл Улаанбаатар хотын төв талбайд Монгол Улсын Төрийн дуулал өнөөдөр нэгэн зэрэг эгшиглэлээ.",
    description2:
      "Энэ нь Монгол Улсын тусгаар тогтнол, бүрэн эрхт байдлыг эрхэмлэн дээдлэх, иргэдийн эх оронч үзэл, үндэсний бахархлыг төлөвшүүлэх, ард түмний эв нэгдлийг бэхжүүлэх зорилготой юм. Монгол Сувд Сүм нь энэхүү өдрийг эрхэмлэн төрийн дууллаа эгшиглүүлж нэгдэн оролцлоо. ",
    category: "Мэдээлэл",
    author: "Kathryn Murphy",
    authorTitle: "Sineor Consultant",
    comment: "356",
    blClass: "format-standard-image",
    col: "col-md-6 col-12",
    styleClass: "blogBlock--style2",
    authorImg: author1,
  },
];
export default medeenuud;
